import styled from 'styled-components';
import {dFlex, dFlexCenter, dFlexStart} from '../../../../globalVariables/GlobalFlex';
import {ellipsisLines, mobileMedia} from '../../../../globalVariables/GlobalVariables';
import {getPrimitive, getSpacing, getFontSize, getFontWeight} from '@tickchak/react-share/app';
import {counts as countsCss} from '../subscriptionRow/SubscriptionRow.css';
import {container} from '../../../../component/modeBtn/ModeBtn.css';

const BORDER_COLOR = getPrimitive('blackAlphas.black05');
export const cardRow = styled.div`
    width: 100%;
    height: 105px;
    ${dFlex};
    border-radius: 5px;
    position: relative;
    border: 0.5px solid ${BORDER_COLOR};
    box-shadow: 2px 4px 4px 2px rgba(211, 211, 211, 0.25);
    cursor: pointer;
    ${mobileMedia}{
        width: 100%;
    }
`;

export const right = styled.div`
    width: 100%;
    display: grid;
    grid-template-rows: 1fr 1fr;
    grid-template-columns: 1fr  fit-content(100%)fit-content(100%);
    padding: ${getSpacing('spaceMd')};
    padding-inline-start: ${getSpacing('spaceLg')};
    gap: ${getSpacing('spaceMd')};
    ${container}{
        height: fit-content;
    }
`;

export const wrap = styled.span`
    ${dFlexCenter}
    gap: ${getSpacing('spaceSm')};
`;

export const startFlex = styled.div`
    ${dFlexStart}
    gap: ${getSpacing('spaceSm')};
`;

export const seriesTitle = styled.div`
    font-weight: ${getFontWeight('bold')};
    font-size: ${getFontSize('body')};
    ${ellipsisLines(2)}
    width: 100%;
    line-height: 1;
`;

export const counts = styled(countsCss)``;
